export default {
  string:(ob)=>{
    ob.filter_type="string";
    return ob;
  },
  integer:(ob)=>{
    ob.filter_type="integer";
    return ob;
  },
  figure_list:(ob)=>{
    ob.filter_type = "remote_list";
    ob.visible_fields = ["name"];
    ob.search_field = "~name";
    ob.title_field = "name";
    ob.list_route = "/api/figure";
    return ob;
  },
  remote_list:(ob)=>{

    return ob;
  },
  date:(ob)=>{
    ob.filter_type="date";
    return ob;
  },
  full_list:(ob)=>{
    ob.filter_type = "full_list";
    if(!ob.list_route) {
      ob.list_route = "/sysapi/local_list/figure_type";
    }
    if(!ob.search_field) {
      ob.search_field = "name";
    }
    if(!ob.title_field) {
      ob.title_field = "name";
    }
    if(!ob.visible_fields) {
      ob.visible_fields = ["name"];
    }
    return ob;
  },
  user:(ob)=>{
    ob.filter_type = "remote_list";
    ob.visible_fields = ["nick", "login", "fio"];
    ob.search_field = "search";
    ob.title_field = "nick";
    ob.list_route = "/sysapi/users";
    return ob;
  },
  yes_no:(ob)=>{
    ob.filter_type="select_yes_no";
    return ob;
  },
  static_list:(ob,list)=>{
    ob.filter_type="static_list";
    ob.list=list;
    return ob;
  },

};